@if (!finishedLoading) {
    <div class="fancy-loader"></div>
} @else if (detailsModel.guid) {
    <div data-uiid="fr-assessment-summary" class="detail-page-summary">
        <div class="row">
            <div class="col-lg-6 left-block">
                <div class="property"><b>{{ 'assessment.summaryId' | transloco }}</b> {{ detailsModel.identifier }}</div>
                <div class="property text-truncate">
                    <b>{{ 'assessment.summaryAssessmentType' | transloco }}</b> {{ detailsModel.assessmentTypeName }}
                </div>
                <div class="property"><b>{{ 'assessment.summaryReviewer' | transloco }}</b> {{ detailsModel.reviewerName }}</div>
            </div>
            <div class="col-lg-6 right-block">
                <div class="property">
                    <b>{{ 'assessment.summaryAssessmentDate' | transloco }}</b> {{ detailsModel.assessmentDate | dateFormat }}
                </div>
                <div class="property">
                    <b>{{ 'assessment.summaryOverallScore' | transloco }}</b>
                    <div
                        class="summary-score-color"
                        [style.background-color]="
                            detailsModel.overallScoreColor ? detailsModel.overallScoreColor : ''
                        "
                    ></div>
                    {{ detailsModel.overallScoreName }}
                </div>
            </div>
        </div>
    </div>
}
<div class="detail-page-card mt-3" [formGroup]="formGroup">
    <div class="detail-page-card-title">{{ 'assessment.detailsTitle' | transloco }}</div>
    <div class="detail-page-card-body padded form-group-styling">
        <div class="row">
            <div class="col-xl-6 left-block">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>{{ 'assessment.labelAssessmentType' | transloco }}</label>
                            <ng-select
                                data-uiid="fr-assessment-assessmenttype"
                                [items]="assessmentTypes"
                                formControlName="assessmentTypeId"
                                bindValue="value"
                                [placeholder]="'assessment.placeholderRequired' | transloco"
                                [loading]="assessmentTypesLoading"
                                (change)="onAssessmentTypeChange($event)"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>{{ 'assessment.labelAssessmentDate' | transloco }}</label>
                            <date-input
                                data-uiid="fr-assessment-assessmentdate"
                                formControlName="assessmentDate"
                                [maxDate]="dateToday"
                            ></date-input>
                        </div>
                    </div>
                </div>
                <div class="form-group-separator"></div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>{{ 'assessment.labelAssessmentUrl' | transloco }}</label>
                            <cerrix-url-input
                                dataUiid="fr-assessment-assessmenturl"
                                formControlName="assessmentUrl"
                            >
                            </cerrix-url-input>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>{{ 'assessment.labelOverallScore' | transloco }}</label>
                            <ng-select
                                data-uiid="fr-assessment-overallscore"
                                [items]="overallScores"
                                formControlName="overallScoreId"
                                bindValue="value"
                            >
                                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                    <span
                                        class="select-template-color"
                                        [style.background-color]="item.color"
                                    ></span>
                                    {{ item.label }}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="form-group-separator"></div>
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>{{ 'assessment.labelReviewer' | transloco }}</label>
                            <ng-select
                                data-uiid="fr-assessment-reviewer"
                                [items]="reviewers"
                                formControlName="reviewerId"
                                bindValue="value"
                                [placeholder]="'assessment.placeholderRequired' | transloco"
                                [loading]="reviewersLoading"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label>{{ 'assessment.labelOrganizationReviewer' | transloco }}</label>
                            <cerrix-select-tree
                                data-uiid="fr-assessment-organizationreviewer"
                                [tree]="reviewerOrganizations"
                                formControlName="reviewerOrganizationId"
                                [multiselect]="false"
                            >
                            </cerrix-select-tree>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 right-block">
                <div class="form-group-separator d-xl-none"></div>
                <div class="row">
                    <div class="form-group col">
                        <cerrix-textarea
                            [fieldLabel]="'assessment.labelCommentsReviewer' | transloco"
                            dataUiid="fr-assessment-commentsreviewer"
                            formControlName="reviewerComments"
                        ></cerrix-textarea>
                    </div>
                </div>
                <div class="form-group-separator d-none d-xl-block"></div>
            </div>
        </div>
    </div>
</div>
<linked-finding-report
    [findingReportGuid]="detailsModel.findingReportGuid"
    showOpenButton="true"
></linked-finding-report>
